export function getSlotMap(slotsInHour: number) { // @TODO: Naming
	const hourSlots = Object.fromEntries(
		[...new Array(slotsInHour)].map((_, key): [number, null] => [key, null]),
	);
	const dayHours = Object.fromEntries(
		[...new Array(24)].map((_, key) => [key, hourSlots]),
	);
	const weekDays = Object.fromEntries((
		[...new Array(7)].map((_, key) => [key + 1, dayHours])
	));
	return JSON.parse(JSON.stringify(weekDays));
}

export function getDaySlotMap(slotsInHour: number) { // @TODO: Naming
	const daySlots = Object.fromEntries((
		[...new Array(24 * slotsInHour)].map((_, key): [number, null] => [key, null])
	));
	const weekDays = Object.fromEntries((
		[...new Array(7)].map((_, key) => [key + 1, daySlots])
	));
	return JSON.parse(JSON.stringify(weekDays));
}
